import clsx from 'clsx'
import styles from './ScrollContainer.module.css'

export default function ScrollContainer({ children, orientation }) {
  return (
    <div
      className={clsx(styles.scrollContainer, {
        [styles.horizontal]: orientation === 'horizontal' || !orientation,
        [styles.vertical]: orientation === 'vertical',
      })}
    >
      {children}
    </div>
  )
}
